import apiRequest from 'helpers/api';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const revokePartnerToken = createAsyncThunk('revokePartnerToken', async partner => {
  const res = await apiRequest(`partner_token_versions/${partner}`, {}, 'DELETE');
  return { partner, token: res.result };
});
